// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a11a4c95","201":"e332958d","235":"851c22fe","327":"797b051c","481":"12d2fa90"}[chunkId] + ".chunk.css";
};